import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // Contenuti gestiti da admin: cache generosa, invalidazione esplicita.
        staleTime: 5 * 60_000,      // 5 min: no refetch tra navigazioni
        gcTime: 30 * 60_000,        // 30 min in memoria
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        retry: 1,
      },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    // Precarica al passaggio del mouse / focus / touchstart.
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
  });

  return router;
};
